// Mock data for Rooney's Barber & Style landing page

export const shopInfo = {
  name: "Rooney's Barber & Style",
  formerName: "McGinnis Barber Shop",
  tagline: "Classic Cuts",
  description: "A well-known barber shop in Starkville, Mississippi, popular with both locals and Mississippi State University students, offering classic haircuts in a traditional, old-school atmosphere with vintage decor.",
  owner: "Pete Mulrooney",
  ownedSince: "2005",
  rating: 4.7,
  totalReviews: 66,
  phone: "(662) 323-4205",
  address: {
    street: "323 University Dr",
    city: "Starkville",
    state: "MS",
    zip: "39759",
    fullAddress: "323 University Dr, Starkville, MS 39759"
  },
  amenities: ["Good for kids", "Restroom"],
  hoursOfOperation: [
    { day: "Monday", hours: "Closed" },
    { day: "Tuesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Wednesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Thursday", hours: "9:00 AM - 5:30 PM" },
    { day: "Friday", hours: "9:00 AM - 5:30 PM" },
    { day: "Saturday", hours: "Closed" },
    { day: "Sunday", hours: "Closed" }
  ]
};

export const services = [
  {
    id: 1,
    name: "Classic Haircut",
    description: "Traditional men's haircut with scissors and clippers, styled to perfection.",
    duration: "30-45 min",
    price: "$20"
  },
  {
    id: 2,
    name: "Beard Trim",
    description: "Professional beard trimming and shaping to maintain your perfect look.",
    duration: "15-20 min",
    price: "$15"
  },
  {
    id: 3,
    name: "Haircut & Beard Combo",
    description: "Complete grooming service combining our classic haircut with beard trim.",
    duration: "45-60 min",
    price: "$25"
  },
  {
    id: 4,
    name: "Kids Haircut",
    description: "Gentle, patient haircuts for children in a welcoming environment.",
    duration: "20-30 min",
    price: "$20"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Michael Thompson",
    rating: 5,
    date: "2 weeks ago",
    text: "Best barber shop in Starkville! Pete and his team are incredibly skilled and friendly. The old-school atmosphere is authentic and relaxing."
  },
  {
    id: 2,
    author: "Sarah Jenkins",
    rating: 5,
    date: "1 month ago",
    text: "My son loves coming here for his haircuts. They're so patient with kids and the place has such a classic, welcoming vibe."
  },
  {
    id: 3,
    author: "David Martinez",
    rating: 5,
    date: "3 weeks ago",
    text: "As an MSU student, I've tried several places in town. This is by far the best. Great cuts at reasonable prices, and the vintage decor is awesome."
  },
  {
    id: 4,
    author: "Robert Anderson",
    rating: 4,
    date: "2 months ago",
    text: "Solid traditional barber shop. No frills, just great service and quality haircuts. Been coming here for years."
  }
];

export const features = [
  {
    id: 1,
    title: "Traditional Atmosphere",
    description: "Experience classic barbering in our authentic vintage setting with old-school decor."
  },
  {
    id: 2,
    title: "Family Friendly",
    description: "Welcoming environment for all ages, especially great for kids and families."
  },
  {
    id: 3,
    title: "Student Favorite",
    description: "Popular with MSU students, offering quality cuts at reasonable prices."
  },
  {
    id: 4,
    title: "Expert Barbers",
    description: "Skilled professionals with years of experience in classic men's grooming."
  }
];
